export const ARROW_UP_PLACE = 0;
export const ARROW_DOWN_PLACE = 1;
export const ARROW_UP_KEYWORD = 'arrow-up';
export const ARROW_DOWN_KEYWORD = 'arrow-down';
export const KEY_WORD_VISIBILITY = 'number';
export const MARGIN_TOP_PENANTY = 22;
export const DISPLAY_TOP_PENALTY = 36;
export const MARGIN_TYPE_PX = 'px';
export const NOT_DISPLAY_POPUP = 0;
